export enum PurchaseTypeEnum {
  FIXED_TERM = 'FIXED_TERM',
  ONE_OFF = 'ONE_OFF',
  ROLLING = 'ROLLING',
}
export enum RequestStepResultEnum {
  ERROR = 'Error',
  FAIL = 'FAIL',
  PASS = 'PASS',
}
export enum RequestStepStateEnum {
  CANCELLED = 'CANCELLED',
  COMPLETE = 'COMPLETE',
  PAUSED = 'PAUSED',
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
}
export enum RequestTypeEnum {
  ACCESS_REQUEST = 'ACCESS_REQUEST',
  ASSESSMENT = 'ASSESSMENT',
  CATALOGUE_PURCHASE = 'CATALOGUE_PURCHASE',
  NEW_PURCHASE = 'NEW_PURCHASE',
  RENEWAL = 'RENEWAL',
  SUB_REQUEST = 'SUB_REQUEST',
  UPDATE_PURCHASE = 'UPDATE_PURCHASE',
}
